const base = '/guest';
// use the same links for signup and signin pages (similar to MAP)
export const guestLinks = {
  root: () => `${base}`,
  authentication: () => `${base}/authentication`,
  register: () => `${base}/authentication/register`,
  forgotPassword: () => `${base}/authentication/forgotPassword`,
  emailVerification: () => `${base}/emailVerification`,
  resetPassword: () => `${base}/resetPassword`,
};
